export default function Variables() {
    return {
        view: 'providerStats',
        provider: null,
        selectedYears: [],
        sellSeriesYears: [],
        yearsInThePast: 4,
        isLoading: false,
        isLoadingSells: false,
        colors: ['#A88AE8', '#009EF6', '#F1416C', '#FFC700', '#50CD89', '#7239EA', '#80CAF4'],
        details: [
            {
                icon: 'users',
                title: 'Gastos totales',
                value: 0,
                ref: 'total_spent',
                currency: true,
                series: [
                    {
                        name: 'Series 1',
                        data: [55, 2, 90, 15, 60, 40, 98, 80],
                    },
                ],
            },
            {
                icon: 'chart-pie',
                title: 'Nº de facturas',
                value: 0,
                ref: 'bills_count',
                series: [
                    {
                        name: 'Series 1',
                        data: [55, 2, 90, 15, 60, 40, 98, 80],
                    },
                ],
            },
            {
                icon: 'layer-group',
                title: 'IVA Soportado',
                value: 0,
                ref: 'iva',
                currency: true,
                series: [
                    {
                        name: 'Series 1',
                        data: [55, 2, 90, 15, 60, 40, 98, 80],
                    },
                ],
            },
        ],
        detailsOptions: {
            dataLabels: {
                enabled: false,
            },
            grid: {
                show: false,
                xaxis: {
                    lines: {
                        show: false,
                    },
                },
                yaxis: {
                    lines: {
                        show: false,
                    },
                },
            },
            chart: {
                type: 'area',
                redrawOnWindowResize: true,
                zoom: {
                    enabled: false,
                },
                sparkline: {
                    enabled: true,
                },
            },
            fill: {
                type: 'gradient',
                colors: ['#103daf'],
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.3,
                    stops: [0, 100],
                },
            },
            stroke: {
                colors: ['#1b55e3'],
                width: 2,
            },
            legend: {
                show: false,
            },
            yaxis: {
                show: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        sellsOptions: {
            chart: {
                type: 'line',
                zoom: {
                    enabled: false,
                },
            },
            responsive: [
                {
                    breakpoint: 481,
                    options: {
                        chart: {
                            height: 400,
                        },
                    },
                },
            ],
            colors: ['#A88AE8', '#009EF6', '#F1416C', '#FFC700', '#50CD89', '#7239EA', '#80CAF4'],
            dataLabels: {
                enabled: false,
                formatter: function (val) {
                    const formatter = new Intl.NumberFormat('es-ES', {
                        style: 'currency',
                        currency: 'EUR',
                        maximumFractionDigits: 0,
                    })

                    return formatter.format(val)
                },
                style: {
                    fontWeight: 500,
                    fontFamily: 'Montserrat,ui-sans-serif',
                },
            },
            stroke: {
                curve: 'smooth',
                width: 2,
            },
            grid: {
                row: {
                    colors: ['transparent', 'transparent'],
                    opacity: 0.5,
                },
            },

            tooltip: {
                enabled: true,
                style: {
                    fontFamily: 'Montserrat,ui-sans-serif',
                },
            },
            xaxis: {
                categories: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            },
            yaxis: {
                labels: {
                    style: {
                        fontFamily: 'Montserrat,ui-sans-serif',
                    },
                    formatter: function (val) {
                        // if (val > 999) {
                        //     const B = 1e9
                        //     const M = 1e6
                        //     const K = 1e3

                        //     if (val >= B) {
                        //         return (val / B).toFixed(2) + 'B'
                        //     } else if (val >= M) {
                        //         return (val / M).toFixed(2) + 'M'
                        //     } else if (val >= K) {
                        //         return (val / K).toFixed() + 'K'
                        //     } else {
                        //         return val.toString()
                        //     }
                        // }
                        const formatter = new Intl.NumberFormat('es-ES', {
                            style: 'currency',
                            currency: 'EUR',
                            maximumFractionDigits: 0,
                        })
                        return formatter.format(val)
                    },
                },
            },
            legend: {
                fontFamily: 'Montserrat,ui-sans-serif',
                formatter: function (seriesName) {
                    return [`<span class="custom-lengend-serie">${seriesName}</span>`]
                },
            },
        },
        sellsSeries: [
            // {
            //     name: 'Periodo 1',
            //     data: [40, 16, 90, 65, 81, 10, 84, 23, 78, 11, 58, 78],
            // },
            // {
            //     name: 'Periodo 2',
            //     data: [21, 29, 27, 5, 27, 50, 98, 48, 79, 6, 64, 47],
            // },
        ],
    }
}
